import {actions} from "../../utils/constants";

export const ReadCustomerInfoAction = (data) =>{
    return { type: actions.READ_CUSTOMER_INFO ,payload:data || false }
}